import React from "react";
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import Card from "../../../components/Card/Card.jsx";
import CardAvatar from "../../../components/Card/CardAvatar.jsx";
import CardBody from "../../../components/Card/CardBody.jsx";

import { vecTeamList } from "../assets"

import teamStyle from "../../../assets/jss/material-kit-pro-react/views/aboutUsSections/teamStyle.jsx";

function SectionTeam(props) {
    const { classes } = props;
    return (
        <div className={classes.team}>
            <GridContainer>
                <GridItem
                    md={8}
                    sm={8}
                    className={classNames(
                        classes.mrAuto,
                        classes.mlAuto,
                        classes.textCenter
                    )}
                >
                    <h2 className={classes.title}>Nuestro Equipo</h2>
                </GridItem>
            </GridContainer>
            <GridContainer>
                {vecTeamList.map(member =>
                    <GridItem lg={3} md={3} sm={6}>
                        <Card profile plain>
                            <CardAvatar profile plain>
                                <img src={member.image} alt={member.name} className={classes.img} />
                            </CardAvatar>
                            <CardBody plain>
                                <h4 className={classes.cardTitle}>{member.name}</h4>
                                <h6 className={classes.textMuted}>{member.role}</h6>
                            </CardBody>
                        </Card>
                    </GridItem>
                )}
            </GridContainer>
        </div>
    );
}

export default withStyles(teamStyle)(SectionTeam);



// WEBPACK FOOTER //
// ./src/views/AboutUsPage/Sections/SectionTeam.jsx